import { isArray } from '@lhb/func';
export default {
    state: {
        selectedEmployeeData: [],
        selectedEmployeeIds: [],
    },
    actions: {},
    mutations: {
        SELECTED_EMPLOYEE: function (state, val) {
            var _a = val || {}, ids = _a.ids, data = _a.data;
            state.selectedEmployeeData = isArray(data) ? data : [];
            state.selectedEmployeeIds = isArray(ids) ? ids : [];
        },
        CLEAR_SELECTED_EMPLOYEE: function (state) {
            state.selectedEmployeeData = [];
            state.selectedEmployeeIds = [];
        }
    },
    getters: {}
};
